// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17xcU","tabsBox":"styles_tabsBox__2r8hp","createButton":"styles_createButton__28ngA"};